import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Import required styles for react-pdf
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

createRoot(document.getElementById('root')).render(<App />);
